import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomDetails from "./routes/ClassRoomDetails";
import ManageFolders from "ManageFolders";
import ClassRoomInsights from "./routes/ClassRoomInsights";
import MyCalendar from "Course/routes/MyCalendar";
import PracticalActivities from "../PracticalActivities";
import RecordOfExperimentalProgrammes from "../RecordOfExperimentalProgrammes";
export default store => ({
  path: "classroom",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-classRoom" */ "./components"),
        import(
          /* webpackChunkName: "course-classRoom" */ "ClassRoom/modules/ClassRoomModule"
        ),
        import(
          /* webpackChunkName: "course-classRoom" */ "UnitPlans/modules/UnitPlanModule"
        ),
        import(
          /* webpackChunkName: "course-classRoom" */ "Assessments/modules/AssessmentModule"
        ),
        import(
          /* webpackChunkName: "course-classRoom" */ "Post/modules/PostModule"
        ),
        import(
          /* webpackChunkName: "course-classRoom" */ "Worksheet/modules/WorksheetModules"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const unitPlanModule = importedModule2.default;
          const assessmentModule = importedModule3;
          const post = importedModule4.default;
          const worksheetModule = importedModule5;
          injectReducer(store, {
            key: "classRoom",
            reducer,
          });
          injectReducer(store, {
            key: "unitPlans",
            reducer: unitPlanModule,
          });
          injectReducer(store, {
            key: assessmentModule.NAME,
            reducer: assessmentModule.default,
          });
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    MyCalendar(store),
    ManageFolders(store),
    ClassRoomInsights(store),
    ClassRoomDetails(store),
    PracticalActivities(store),
    RecordOfExperimentalProgrammes(store),
  ],
});
